import { render, staticRenderFns } from "./UILogo.vue?vue&type=template&id=3057fd68&scoped=true"
import script from "./UILogo.vue?vue&type=script&lang=js"
export * from "./UILogo.vue?vue&type=script&lang=js"
import style0 from "./UILogo.vue?vue&type=style&index=0&id=3057fd68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3057fd68",
  null
  
)

export default component.exports